import { BounceZoomIn, SwipeFromBottomOut, ZoomOut } from 'slotworks/graphics/animation/base-animations';
import Layers from 'slotworks/graphics/layers/layers';
import { AbstractSceneTransition } from 'slotworks/graphics/layers/scene-transitions/abstract-scene-transition';
import { CenterPivot } from 'slotworks/graphics/pixi/group';
import gameState from 'slotworks/model/game-state';
import settingsModel from 'slotworks/model/settings/settings-model';
import soundManager from 'slotworks/sound/sound-manager';
import Contract from 'slotworks/utils/contract';
import deviceInfo from 'slotworks/utils/device-info';
import Point from 'slotworks/utils/geom/point';
import Timer from 'slotworks/utils/timer';
import * as TweenJS from 'slotworks/utils/tween';

export default class TotalWinTransition extends AbstractSceneTransition {
    private BOUNCE_TIME: number = 400;
    private SWIPE_TIME: number = 500;
    private total_win_value: any;
    private tweenTimer: any;
    private lowWinOnUk: boolean;

    public in(): Contract<void> {
        return new Contract(resolve => {
            this.lowWinOnUk = settingsModel.isUKJurisdiction() && !gameState.getCurrentGame().isWinAboveBet();
            if (!this.lowWinOnUk && Layers.CelebrationContent.getSprite('value')) {
                BounceZoomIn(Layers.CelebrationContent.getSprite('value'), this.BOUNCE_TIME, 0).then(resolve);
            } else resolve(null);
        });
    }

    public skipIn() {
        TweenJS.remove(this.total_win_value);
        Timer.clearTimeout(this.tweenTimer);
    }

    public out(): Contract<void> {
        if (this.lowWinOnUk) return Contract.empty();
        return new Contract(resolve => {
            SwipeFromBottomOut(Layers.CelebrationContent.getSprite('value'), this.SWIPE_TIME + 1, 0, TweenJS.Easing.Back.In).then(resolve);
            ZoomOut(Layers.CelebrationContent.getSprite('value'), this.SWIPE_TIME * 0.75, this.SWIPE_TIME * 0.25, TweenJS.Easing.Quadratic.In).execute();

            TweenJS.remove(this.total_win_value);
            if (deviceInfo.isDesktop) {
                Timer.setTimeout(() => {
                    let pivot: Point = new Point(0, 0.5);
                    CenterPivot(Layers.BetBar.getText('total_win_value'), null, pivot).scale.set(1, 1);
                    this.total_win_value = new TweenJS.Tween(CenterPivot(Layers.BetBar.getText('total_win_value'), null, pivot).scale)
                        .to({ x: 1.5, y: 1.5 }, 450)
                        .yoyo(true)
                        .repeat(1)
                        .easing(TweenJS.Easing.Bounce.Out);
                    this.total_win_value.start();
                }, this.SWIPE_TIME * 0.75 + this.SWIPE_TIME * 0.25);
            }
            this.tweenTimer = Timer.setTimeout(() => {
                soundManager.customEvent('line_wins_scale_out');
            }, this.SWIPE_TIME + 1);
        });
    }
}



// WEBPACK FOOTER //
// ./src/transitions/total-win-transitions.ts